import { IconButton, Modal } from "@mui/material";
import { useIsAdmin } from "utils/customHooks/genericHooks";
import { Close, OpenInNew } from "@mui/icons-material";
import { useAtom } from "jotai";
import styled from "styled-components/macro";
import { CustomJsonEditor } from "components/Nav/Drawers/RightDrawer/FlightDebugger/debuggerComponents/CustomJsonEditor";
import useWindowSize from "utils/customHooks/useWindowSize";
import { blueNotification, brightBlue } from "constants/colors";
import { customerTilesPopupDataAtom } from "./internalToolsUtils";

export function CustomerTilesInspectPopup() {
  const isAdminUser = useIsAdmin();
  const [{ ckey, popupData, adminUrls }, setPopupData] = useAtom(
    customerTilesPopupDataAtom
  );
  function handleClose() {
    setPopupData({ ckey: "", popupData: null });
  }
  const { innerWidth } = useWindowSize();
  if (!isAdminUser) {
    return null;
  }
  return (
    <StyledModal
      open={Boolean(ckey)}
      onClose={handleClose}
      disableScrollLock={true}
    >
      <div className="modalContent">
        <IconButton
          onClick={() => {
            handleClose();
          }}
          className="btnClose"
        >
          <Close style={{ color: "white" }} />
        </IconButton>
        <div className="header">
          {ckey} — {adminUrls?.map(({ name }) => name).join(", ")}{" "}
          <div className="urls">
            {adminUrls?.map(({ name, url }) => (
              <a
                className="admin-url"
                target="_blank"
                rel="noreferrer noopener"
                href={url}
                key={name}
              >
                <OpenInNew /> <div className="text">{name}</div>
              </a>
            ))}
          </div>
        </div>
        <CustomJsonEditor value={popupData ?? {}} width={innerWidth - 128} />
      </div>
    </StyledModal>
  );
}
const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  z-index: 10000;
  .modalContent {
    position: relative;
  }
  .btnClose {
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    cursor: pointer;
    z-index: 10001;
    width: 32px;
    height: 32px;
  }
  .header {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 16px;
    padding-right: 16px;
    height: 32px;
    font-family: sans-serif;
    font-size: 14px;
    color: #fff;
    cursor: move;
    cursor: grab;
    /* disabling user selection inorder to avoid unnecessary text selection or drags */
    user-select: none;
    background-color: #000;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: ${props => (props.$collapsed ? 8 : 0)}px;
    border-bottom-right-radius: ${props => (props.$collapsed ? 8 : 0)}px;
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.14);
    .urls {
      position: absolute;
      right: 32px;
      display: flex;
      align-items: center;
      gap: 1em;
    }
  }
  .admin-url {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${blueNotification};
    transition: color 0.2s;
    &:hover {
      color: ${brightBlue};
    }
  }
`;
